import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth";
import { useAppContext } from "../../config/AppContext.js";
import Icon1 from "../../icons/Icon.js";
import { getDocDataById } from "../../models/DataFunctions.js";
import MasterSmallStats from "./MasterSmallStats.js";
import { User } from "../../types/user.js";
import { Org, Workspace } from "../../types/org.js";

type HomeProps = {
  userData: User; // Replace 'any' with a more specific type if available
  orgData: Org; // Replace 'any' with a more specific type if available
  navigateWorkspace: (path: string) => void;
  workspaceData?: Workspace; // Replace 'any' with a more specific type if available
  overrideId?: string;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
};

function Home({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
  overrideId,
  handleClickVariant,
}: HomeProps) {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [promotion_open, setPromotionOpen] = useState(
    appState.promotions && appState.promotions["hexagone-logement"] === false
      ? false
      : true
  );

  const [promotion, setPromotion] = useState<any>(null);
  // Display loading message while checking authentication or fetching user data
  // If the data is still loading, show skeletons
  // loading || !currentUser || !userData
  const handleFetchData = async () => {
    let promotion = await getDocDataById("maintenance", "promotion");
    if (promotion) {
      setPromotion(promotion);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  useEffect(() => {
    // Redirect to carnets if org doesn't have carnet creation access
    if (orgData && orgData.logement?.access?.can_create !== true) {
      navigateWorkspace("/carnets");
    }
  }, [orgData]);

  // Function to fetch user and organization data

  if (!orgData) {
    return <></>;
  }

  return (
    <div className="flex flex-col h-full overflow-y-auto pl-4  ">
      <div className="flex flex-col h-fit pb-20">
        <div className="text-hx text-black font-medium  ">Accueil</div>
        {!workspaceData &&
          promotion?.active &&
          promotion?.type === "mobileapp" && (
            <div
              onClick={() => {
                navigateWorkspace("/mobileapp");
              }}
              className="flex relative cursor-pointer flex-col gap-2 rounded-2xl  border  h-fit w-c1k  mt-4"
            >
              <div className=" w-full h-full ">
                <img
                  src="https://i.ibb.co/0R5kSn49/image.png"
                  className="rounded-xl"
                ></img>
              </div>
            </div>
          )}
        {promotion?.active && promotion?.type === "hexagone-logement" && (
          <div
            onClick={() => {
              navigateWorkspace("/recharge?section=parrainage");
            }}
            className="flex relative cursor-pointer hover:outline-none hover:outline-2 hover:outline-indigo-300 flex-col gap-2 rounded-lg  h-fit w-c1k  mt-4"
          >
            <div className="absolute z-20 w-full h-full gap-1  flex flex-col items-start justify-center p-4 pl-32">
              <div className="text-white text-hx ">
                Parrainez un <span className="font-semibold">confrère</span>
              </div>{" "}
              <div className="text-wshadow_75 text-h1 text- ">
                600€ offerts pour chaque parrainage
              </div>
            </div>
            <div className=" w-full h-full ">
              <img
                src="https://i.ibb.co/kVbpJsV3/Banni-re-Google-Play-500-x-100-px-6.png"
                className="rounded-xl"
              ></img>
            </div>
          </div>
        )}

        {!workspaceData && (
          <div className=" flex flex-col gap-2 ">
            <MasterSmallStats
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              userData={userData}
              handleClickVariant={handleClickVariant}
            ></MasterSmallStats>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
